// stores/authStore.js
import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    _token: null,
    user: null,
  }),
  getters: {
    token: (state) => state._token,
    isAuthenticated: (state) => !!state._token,
    username: (state) => state.user?.phone || state.user?.username || "", // 优先使用手机号作为用户名
  },
  actions: {
    setToken(token) {
      console.log("设置 token222:", token); // 调试：打印 token
      if (!token) {
        console.error("尝试设置的 token 为空");
        return;
      }
      this._token = token;
      // console.log("设置 token:", token);

      // // 手动触发持久化
      // this.$persist();
      // 手动写入 localStorage 确保持久化
      const authData = {
        _token: this._token,
        user: this.user,
      };
      localStorage.setItem("auth", JSON.stringify(authData));
    },
    setUser(user) {
      this.user = user;

      // 同步写入 localStorage
      const authData = {
        _token: this._token,
        user: this.user,
      };
      localStorage.setItem("auth", JSON.stringify(authData));
    },

    // 添加 login 方法
    login(payload) {
      this.setToken(payload.token);
      this.setUser({ username: payload.username });
    },
    logout() {
      this._token = null;
      this.user = null;
      localStorage.removeItem("auth"); // 确保完全清除
    },
  },
  // 持久化存储
  persist: {
    enabled: true,
    strategies: [
      {
        key: "auth",
        storage: localStorage,
        paths: ["_token", "user"], // 明确指定要持久化的字段
        // 添加序列化处理器
        // serializer: {
        //   serialize: JSON.stringify,
        //   deserialize: JSON.parse,
        // },
      },
    ],
  },
});
